<script>
  import { getContext } from "svelte";
  import { Link } from "svelte-routing";
  import ItemClip from "#lib/sidebar/ItemClip.svelte";
  import Viewport from "#lib/drawing/ViewportFixed.svelte";
  import liteDrawing from "@local/extensions/drawing/lite-drawing.js";
  import { UX_MODE } from "#src/env.js";

  const typeColors = getContext("typeColors");
  export let item;
  export let group;
  export let locations;
  export let isCollection;

  function lb(item) {
    return item.is_collection ? $group.data.settings.collections_label_by : $group.data.settings.label_by;
  }
</script>

{#if Array.isArray(item.id)}
  <div class="w-36 h-36 border border-gray-300 flex items-center justify-center">
    <div class="text-xs text-gray-500 italic p-1">Multiple Selected</div>
  </div>
{:else if UX_MODE === "shpx"}
  <div class="w-36 h-36 relative flex items-center justify-center">
    {#if item.drawing && item.replace_with_drawing}
      <ItemClip {group} {item} {locations} />
    {:else}
      <Viewport
        paddingTop={4}
        paddingRight={4}
        paddingBottom={50}
        paddingLeft={4}
        drawing={liteDrawing(item, {
          isCollection: item.is_collection,
          labelBy: lb(item),
          typeColor: $typeColors[item.type_id],
        })}
        width={136}
        height={136} />
    {/if}
  </div>
{:else}
  <Link to={`${isCollection ? "openings" : "items"}/${item.id}`}>
    <div class="w-36 h-36 relative flex items-center justify-center">
      {#if item.drawing && item.replace_with_drawing}
        <ItemClip {group} {item} {locations} />
      {:else}
        <Viewport
          paddingTop={4}
          paddingRight={4}
          paddingBottom={50}
          paddingLeft={4}
          drawing={liteDrawing(item, {
            isCollection: item.is_collection,
            labelBy: lb(item),
            typeColor: $typeColors[item.type_id],
          })}
          width={136}
          height={136} />
      {/if}
    </div>
  </Link>
{/if}
